var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_101564)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.22656C5.55228 7.22656 6 7.67428 6 8.22656V18.5057C6 19.3341 6.67158 20.0057 7.50001 20.0057L15.1589 20.0057C15.7112 20.0056 16.1589 20.4534 16.1589 21.0056C16.1589 21.5579 15.7112 22.0056 15.159 22.0057L7.50003 22.0057C5.56702 22.0057 4 20.4387 4 18.5057V8.22656C4 7.67428 4.44772 7.22656 5 7.22656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18H18C19.1046 18 20 17.1046 20 16V7.64547C20 7.07574 19.757 6.53305 19.332 6.1536L16.3691 3.50812C16.0026 3.18088 15.5284 3 15.0371 3H10C8.89543 3 8 3.89543 8 5V16C8 17.1046 8.89543 18 10 18Z",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_101564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c96d2bbc677167ac6861bf4d190575b4.svg";
export { ForwardRef as ReactComponent };